/**
 * Copyright (C) 2019 User X, LLC http://whoisuserx.com <info@userx.co>
 *
 * This program is the intellectual property of User X, LLC. You may
 * not redistribute and/or modify it without written consent by controlling
 * entities of User X, LLC.
 *
 * You should have received a copy of our Web Developer Agreement which
 * outlines proper use and distribution of this program. If you did not
 * please email info@userx.co to request your copy.
 */
/**
 * File created by John M. Woodcock < john@userx.co >
 * on 1/3/2023
 * for userx-support
 */

import React, {useContext} from "react";
import {UserContext} from "../../_contexts/UserContext";
import {Navigate, useLocation} from "react-router-dom";
import {useParams} from "react-router";
import {addNotification} from "../../_utilities/notificationUtilities";

const PrivateRoute = ({children}) => {
    const {userContext} = useContext(UserContext);
    const { agentId, clientId } = useParams();
    const location = useLocation();

    if (!userContext.isLoggedIn) {
        return <Navigate to={"/login"} replace state={{from: location}} />;
    }

    const groupId = String(userContext?.contact?.group_id ?? "");
    const companies = Array.isArray(userContext?.contact?.company)
        ? userContext.contact.company
        : [];

    // 🚫 Prevent clients or agents from accessing admin URLs
    if (location.pathname.includes("/admins")) {
        if (groupId !== "1") {
            return <Navigate to="/" replace />; // or send them to their dashboard
        }
    }

    if(groupId === "5"){
        if(agentId){
            // not allowed here
            return <Navigate to={`/clients`} replace />;
        }
        if(clientId){
            const requested = String(clientId);
            const allowed = companies.some(co => String(co.company_id) === requested);

            console.log('companies',companies);
            console.log('allowed',allowed);

            if(!allowed){
                const first = companies[0]?.company_id;
                return first
                    ? <Navigate to={`/clients/${first}`} replace />
                    : <Navigate to={`/clients`} replace />;
            }
        }
    }

    return children;
}

export default PrivateRoute;